import _ from 'lodash'
import Vue from 'vue'
export default {
  namespaced: true,
  state: {
    livingOptions: [],
    subsections: [],
    properties: [],
    dwellings: [],
    packages: [],
    turnkeys: [],

    activeSlideId: '',

    activeVirtualTourUrl: ''
  },

  mutations: {
    SET_LIVING_OPTIONS (state, livingOptions) {
      state.livingOptions = livingOptions
    },

    SET_SUBSECTIONS (state, subsections) {
      state.subsections = subsections
    },

    SET_PROPERTIES (state, properties) {
      state.properties = properties
    },

    SET_DWELLINGS (state, dwellings) {
      state.dwellings = dwellings
    },

    SET_TURNKEYS (state, turnkeys) {
      state.turnkeys = turnkeys
    },
    
    SET_PACKAGES (state, packages) {
      state.packages = packages
    },

    SET_ACTIVE_SLIDE_ID: (state, id) => {
      state.activeSlideId = id
    },

    SET_ACTIVE_VIRTUAL_TOUR_URL: (state, id) => {
      state.activeVirtualTourUrl = id
    },
  },

  getters: {
    activeSlide: (state) => {
      const slide = state.packages.find(_package => _package._id === state.activeSlideId)

      if (slide) {
        return slide

      } else {
        return null
      }
    },

    activeLivingOption: (state, getters, rootState) => {
      const livingOptionId = rootState.route.params.livingOptionId
      if (!livingOptionId) return null
      return _.find(getters.livingOptions, livingOption => {
        return livingOption._id === livingOptionId
      })
    },

    activeLivingOptionSubsections (state, getters, rootState) {
      const routeName = rootState.route.name

      if (['living-option', 'subsection'].includes(routeName)) {        
        return _.sortBy(getters.activeSubsections, subsection => {
          const [marker] = subsection.markers || []
          return marker ? marker.x : Number.MAX_SAFE_INTEGER
        })
      }
      
      return []
    },

    activeLivingOptionProperties (state, getters, rootState) {
      const routeName = rootState.route.name

      if (['subsection', 'property'].includes(routeName)) {
        if (getters.activeSubsection.subsections && getters.activeSubsection.subsections.length) return []
        return _.sortBy(getters.activeProperties, property => {
          return property.marker ? property.marker.x + property.marker.y : Number.MAX_SAFE_INTEGER
        })
      }

      if (rootState.route.name === 'live-display-homes' || rootState.route.name === 'live-display-homes-property') {
        return _.sortBy(getters.activeProperties, property => {
          return property.marker ? property.marker.x + property.marker.y : Number.MAX_SAFE_INTEGER
        })
      }  
      
      return []
    },

    activeLivingOptionTags (state, getters, rootState) {
      const routeName = rootState.route.name
      const pathway = rootState.route.params.pathway
      if (getters.activeSubsectionTags.length) return []
      if (['living-entry'].includes(routeName)) {
        if (pathway === 'masterplan') {
          return _.sortBy(getters.livingOptions, livingOption => {
            const [marker] = livingOption.markers || []
            return marker ? marker.x : Number.MAX_SAFE_INTEGER
          })
        }

        if (pathway === 'land') {
          return _.sortBy(getters.livingOptionsLand, livingOption => {
            const [marker] = livingOption.markers || []
            return marker ? marker.x : Number.MAX_SAFE_INTEGER
          })
        }

        if (pathway === 'townhouses') {
          return _.sortBy(getters.livingOptionsTownhouses, livingOption => {
            const [marker] = livingOption.markers || []
            return marker ? marker.x : Number.MAX_SAFE_INTEGER
          })
        }

        if (pathway === 'apartments') {
          return _.sortBy(getters.livingOptionsApartments, livingOption => {
            const [marker] = livingOption.markers || []
            return marker ? marker.x : Number.MAX_SAFE_INTEGER
          })
        }

        if (pathway === 'houses') {
          return _.sortBy(getters.livingOptionsHouses, livingOption => {
            const [marker] = livingOption.markers || []
            return marker ? marker.x : Number.MAX_SAFE_INTEGER
          })
        }

        return _.sortBy(getters.livingOptions, livingOption => {
          const [marker] = livingOption.markers || []
          return marker ? marker.x : Number.MAX_SAFE_INTEGER
        })

      }
      
      return []
    },

    activeSubsectionTags (state, getters) {
      if (!getters.activeSubsections) return []
      if (getters.activeSubsection && (getters.activeSubsections.map(subsection => subsection.id).includes(getters.activeSubsection._id))) return []
      return _.sortBy(getters.activeSubsections, subsection => {
        const [marker] = subsection.markers || []
        return marker ? marker.x : Number.MAX_SAFE_INTEGER
      })      
    },

    activeParentSubsection (state, getters) {
      if (!getters.activeSubsection) return null
      if (!getters.activeSubsection.parent.id) return null
      return getters.subsections.find(subsection => subsection._id === getters.activeSubsection.parent.id)
    },

    activeProperty: (state, getters, rootState) => {
      if (rootState.route.params.propertyId) {
        let property = _.find(getters.properties, property => {
          return property._id === rootState.route.params.propertyId
        })

        if (!property) return null

        const associatedPackages = state.packages.filter(_package => {
          return _package.active && _package.property.label === property.label
        })

        property['associatedPackages'] = associatedPackages

        return property
      } else {
        return null
      }
    },

    activeProperties: (state, getters, rootState, rootGetters) => {
      if (!getters.activeSubsection) return []
      return getters.activeSubsection.properties.map(property => {
        const productType = getters.activeSubsection.type.charAt(getters.activeSubsection.type.length - 1) === 's' ? getters.activeSubsection.type.substring(0, getters.activeSubsection.type.length - 1) : (getters.activeSubsection.type || 'land')
        property.productType = productType

        // filter properties
        Vue.set(property, 'filtered', false)
        if (rootGetters['filter/inputType']) {
          const dwelling = state.dwellings.find(dwelling => dwelling._id === property.dwellingId)
          if (dwelling && dwelling.type.toLowerCase() !== rootGetters['filter/inputType'].toLowerCase()) {
            Vue.set(property, 'filtered', true)
          }
        }

        if (rootGetters['filter/inputBeds']) {
          const dwelling = state.dwellings.find(dwelling => dwelling._id === property.dwellingId)
          if (dwelling) {
            let beds = parseInt(dwelling.beds)
            if (beds > 4) beds = 4
            if (beds !== rootGetters['filter/inputBeds']) {
              Vue.set(property, 'filtered', true)
            }
          }
        }

        if (rootGetters['filter/inputView']) {
          if (rootGetters['filter/inputView'].toLowerCase() !== property.viewLabel.toLowerCase()) {
            Vue.set(property, 'filtered', true)
          }
        }

        return property
      })
    },

    activeSubsection: (state, getters, rootState) => {      
      if (rootState.route.params.livingOptionId && rootState.route.params.subsectionId) {
        return _.find(getters.subsections, subsection => {
          return subsection._id === rootState.route.params.subsectionId
        })
      } else if (rootState.route.name === 'live-display-homes' || rootState.route.name === 'live-display-homes-property') {
        return _.find(getters.subsections, subsection => {
          return subsection.isDisplayVillage
        })
      } else {
        return null
      }
    },

    activeSubsections: (state, getters, rootState) => {      
      const pathway = rootState.route.params.pathway
      const parentSubsectionId = rootState.route.query.parentSubsectionId

      let activeSubsections = []

      if (getters.activeSubsection && parentSubsectionId && !getters.activeSubsection.subsectionIds.length) {
        const parentSubsection = getters.subsections.find(subsection => parentSubsectionId === subsection._id)
        parentSubsection.subsectionIds.forEach(subsectionId => {
          const activeSubsection = _.find(getters.subsections, subsection => { return subsection._id === subsectionId })
          if (activeSubsection) {
            activeSubsections.push(activeSubsection)
          }
        })
  
        return activeSubsections
      }

      if (getters.activeSubsection) {
        getters.activeSubsection.subsectionIds.forEach(subsectionId => {
          const activeSubsection = _.find(getters.subsections, subsection => { return subsection._id === subsectionId })
          if (activeSubsection) {
            activeSubsections.push(activeSubsection)
          }
        })
  
        return activeSubsections
      }

      if (getters.activeLivingOption) {
        return getters.activeLivingOption.subsectionIds.map(id => {
          return getters.subsections.find(subsection => subsection._id === id)
        })
        // return getters.activeLivingOption.subsections
      }

      return []
    },

    activeVirtualTourUrl: (state) => {
      return state.activeVirtualTourUrl
    },

    livingOptions: (state, getters, rootState) => {
      if (rootState.hideLivingOptions) return state.livingOptions.filter(item => !rootState.hideLivingOptions.split(',').includes(item._id))
      return state.livingOptions
    },

    livingOptionsApartments: (state, getters, rootState, rootGetters) => {
      if (getters.livingOptions.length) {
        return getters.livingOptions.filter(livingOption => {
          let show = false

          // show if living option subsections contain land
          livingOption.subsections && livingOption.subsections.forEach(subsection => {
            if (subsection.type === 'apartments') {
              show = true
            }
          })

          // hide if sold out
          if (livingOption.availablePropertiesCount === 0 && !rootGetters.styleTemplate['general']['show-sold-neighbourhoods']) {
            show = false
          }
          
          return show
        })
      } else {
        return []
      }
    },   

    livingOptionsHouses: (state, getters, rootState, rootGetters) => {
      if (getters.livingOptions.length) {
        return getters.livingOptions.filter(livingOption => {
          let show = false

          // show if living option subsections contain land
          livingOption.subsections && livingOption.subsections.forEach(subsection => {
            if (subsection.type === 'houses') {
              show = true
            }
          })

          // hide if sold out
          if (livingOption.availablePropertiesCount === 0 && !rootGetters.styleTemplate['general']['show-sold-neighbourhoods']) {
            show = false
          }
          
          return show
        })
      } else {
        return []
      }
    },

    livingOptionsLand: (state, getters, rootState, rootGetters) => {
      if (getters.livingOptions.length) {
        return getters.livingOptions.filter(livingOption => {
          let show = false

          // show if living option subsections contain land
          livingOption.subsections && livingOption.subsections.forEach(subsection => {
            if (subsection.type === 'land') {
              show = true
            }
          })

          // hide if sold out
          if (livingOption.availablePropertiesCount === 0 && !rootGetters.styleTemplate['general']['show-sold-neighbourhoods']) {
            show = false
          }
          
          return show
        })
      } else {
        return []
      }
    },

    livingOptionsTownhouses: (state, getters, rootState, rootGetters) => {
      if (getters.livingOptions.length) {
        return getters.livingOptions.filter(livingOption => {
          let show = false

          // show if living option subsections contain land
          livingOption.subsections && livingOption.subsections.forEach(subsection => {
            if (subsection.type === 'townhouses') {
              show = true
            }
          })

          // hide if sold out
          if (livingOption.availablePropertiesCount === 0 && !rootGetters.styleTemplate['general']['show-sold-neighbourhoods']) {
            show = false
          }
          
          return show
        })
      } else {
        return []
      }
    },

    livingOptionsPackages: (state) => {
      return state.packages
    },

    packages: (state) => {
      return state.packages
    },

    livingOptionsDwellings: (state) => {
      return state.dwellings
    },

    land: state => {
      if (state.properties.length === 0) return []
      let land = _.filter(state.properties, property => !property.dwelling)
      return land
    },

    townhouses: (state) => {
      if (state.properties.length === 0) return []
      let townhouses = _.filter(state.properties, property => property.dwelling && property.dwelling.type === 'townhouse') 
      return townhouses
    },

    apartments: (state) => {
      if (state.properties.length === 0) return []
      let apartments = _.filter(state.properties, property => property.dwelling && property.dwelling.type === 'apartments') 
      return apartments
    },

    houses: (state) => {
      if (state.properties.length === 0) return []
      let houses = _.filter(state.properties, property => property.dwelling && property.dwelling.type === 'house') 
      return houses
    },

    dwellingTypes: (state) => {
      return _.uniq(state.dwellings.map(dwelling => dwelling.type.toLowerCase()))
    },

    properties: (state) => {
      return state.properties
    },

    dwellings: (state) => {
      return state.dwellings
    },

    turnkeys: (state) => {
      return state.turnkeys
    },

    // Returns an array of Subsection objects with their associated Properties nested inside
    // Also sets a "filter" flag to true if all properties have been filtered out
    // Also handles nested subsections
    subsections: (state) => {
      return state.subsections
    },
  }
}
